module.exports = __webpack_public_path__ + "static/media/5_avatar.9ce7771f.png";